export default theme => ({
  containerDesktop: {
    height: '100%',
    width: '100%',
    position: 'relative',
  },
  containerMobile: {
    width: '100%',
    height: '100%',
    // overflowX: 'hidden',
    '& > *': {
      display: 'block',
    },
  },
  arrow: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    color: theme.palette.white.main,
    '& svg': {
      ' -webkit-filter': 'drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7))',
      filter: 'drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7))',
    },
  },
  arrowBack: {
    left: theme.spacing(1),
    '& svg': {
      transform: 'translateX(5px)',
    },
  },
  arrowNext: {
    right: theme.spacing(1),
    '& svg': {
      transform: 'translateX(2px)',
    },
  },
});
